import autoComplete from '@tarekraafat/autocomplete.js/dist/autoComplete.js';

export class AutoComplete {
	constructor() {
		this.setupSearch('autoComplete-mobile')
		this.setupSearch('autoComplete-desktop')
	}
	setupSearch(selector) {
		const autoCompleteJS = new autoComplete({
			selector: '#' + selector,
			placeHolder: "Search by product name or ID.",
			data: {
				src: async () => {
					try {
						document.getElementById(selector).closest('form').classList.add('loading')
						const formData = new FormData();
						formData.append('action', 'autocomplete');
						formData.append('nonce', ajax_params.ajaxNonce);
						formData.append('search', autoCompleteJS.input.value)
						const source = await fetch(ajax_params.ajaxurl, {
							method: "POST",
							credentials: 'same-origin',
							body: formData
						})
						const data = await source.json();
						
						return data;
					} catch (error) {
						return error;
					}
				},
				keys: ['name', 'id'],
				cache: false,
				filter: (list) => {
					const filteredResults = Array.from(
						new Set(list.map((value) => value.match))
					).map((key) => {
						return list.find((value) => value.match === key);
					});
					document.getElementById(selector).closest('form').classList.remove('loading')
					return filteredResults;
				},
			},
			resultsList: {
				element: (list, data) => {
					if (!data.results.length) {
						// Create "No Results" message element
						const message = document.createElement("div");
						// Add class to the created element
						message.setAttribute("class", "no_result");
						// Add message text content
						message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
						// Append message element to the results list
						list.prepend(message);
					}
				},
				noResults: true,
			},
			resultItem: {
				element: (item, data) => {
					if(autoCompleteJS.input.value === '') {
						item.innerHTML = ''
					} else {
					// Modify Results Item Style
					item.style =
						'display: flex; justify-content: space-between;';
					// Modify Results Item Content
					let image = ''
					let brand = ''
					if (data.value.image) {
						image = `<img src="${data.value.image}">`
					}
					if (data.value.brand) {
						brand = `<div class="autocomplete-brand">${data.value.brand}</div>`
					}
					item.innerHTML = `
  	<a href="${data.value.link}" class="autocomplete-wrapper">
	  <div class="autocomplete-image-wrapper"><div class="autocomplete-image">${image}</div></div>
		<div class="autocomplete-content">
			${brand}
			<div class="autocomplete-title">${data.value.name}</div>
			<div class="autocomplete-id">${data.value.id}</div>
			<div class="autocomplete-price">£${data.value.price} <span>/ unit</span></div>
		</div>
	</a>
`;
				}
				},
				highlight: true,
			},
			events: {
				input: {
					keyup: (e) => {
						if (!autoCompleteJS.input.value.length) {
							autoCompleteJS.close();
						}
						if (e.keyCode !== 38 && e.keyCode !== 40 && e.keyCode !== 37 && e.keyCode !== 39) {
							if (!autoCompleteJS.input.value.length) {
								document.getElementById(selector).closest('form').classList.remove('loading')
							} else {
								document.getElementById(selector).closest('form').classList.add('loading')
							}
						} else {
							document.getElementById(selector).closest('form').classList.remove('loading')
						}
						if (e.keyCode === 13 && autoCompleteJS.input.value.length) {
							window.location.href = '/?s=' + autoCompleteJS.input.value
							document.getElementById(selector).closest('form').classList.remove('loading')
						}
					},
				},
			}
		});

		autoCompleteJS.input.addEventListener(
			'selection',
			function (event) {
				const feedback = event.detail;
				window.location.href = feedback.selection.value.link
			}
		);
	}
}


